import React, { useState } from 'react';
import shortid from 'shortid';
import Nav from '../Components/Common/Nav';
import Setup from '../Components/Setup';

const CreateRoom = (props) => {

    const [roomid] = useState(shortid.generate())

    return (
        <>
            <Nav/>
            <Setup roomId={roomid}/>
        </>
    );
}

export default CreateRoom;